import { render, staticRenderFns } from "./StaffCombo.vue?vue&type=template&id=8c1ac314&"
import script from "./StaffCombo.vue?vue&type=script&lang=js&"
export * from "./StaffCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports